<div class="container-fluid">
    <div class="row">
      <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 class="mb-sm-0">System Users</h4>

              <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a routerLink="/dashboard">Menu</a></li>
                      <li class="breadcrumb-item active">System Users</li>
                  </ol>
              </div>

          </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-xl-12">
          <div class="card">
              <div class="card-header align-items-center d-flex">
                  <h4 class="card-title mb-0 flex-grow-1">System Users</h4>
                  <div class="flex-shrink-0">
                    <a routerLink="/system-user/add" class="btn btn-primary waves-effect waves-light">Add System User</a>
                  </div>
              </div><!-- end card header -->

              <div class="card-body">
                  <div class="live-preview">
                      <div class="table-responsive table-card">
                          <table class="table align-middle table-nowrap mb-0">
                              <thead class="table-light">
                                  <tr>
                                      <th scope="col">Created Date</th>
                                      <th scope="col">Name</th>
                                      <th scope="col">Email</th>
                                      <th scope="col">Status</th>
                                      <th scope="col" style="width: 150px;">Action</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr *ngFor="let user of users | paginate: paginationConfig">
                                      <td>{{ user.created_at | date:'dd/MM/yyyy' }}</td>
                                      <td>{{ user.first_name }} {{  user.last_name }}</td>
                                      <td>{{ user.email }}</td>
                                      <td>
                                        <app-badge-status [statusLabel]="user.status_label" />
                                      </td>
                                      <td>
                                          <a [routerLink]="['/system-user/details', user.id]" class="btn btn-sm btn-light">View</a>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </div>
                      <div class="text-end mt-4" *ngIf="(paginationConfig?.totalItems ?? 0) > 0">
                          <pagination-controls id="{{ paginationConfig.id }}"
                            (pageChange)="getSystemUsers($event)" previousLabel="Previous" nextLabel="Next"></pagination-controls>
                      </div>
                  </div>
              </div><!-- end card-body -->
          </div><!-- end card -->
      </div><!-- end col -->
  </div>


  </div>
